import { Model } from "pinia-orm";
import BatchScenario from "@/models/BatchScenario";
import QuestionBatch from "@/models/QuestionBatch";

export default class Batch extends Model {
  static entity = "batches";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      isMandatory: this.boolean(false),
      isRandomized: this.boolean(true),
      questionsCount: this.number(1),
      batchScenariosData: this.belongsTo(BatchScenario, "batchUuid"),
      questionBatchsList: this.hasMany(QuestionBatch, "batchUuid"),
    };
  }
}
